import { render, staticRenderFns } from "./DashboardEgressProfile.vue?vue&type=template&id=06fd25e2&scoped=true"
import script from "./DashboardEgressProfile.vue?vue&type=script&lang=js"
export * from "./DashboardEgressProfile.vue?vue&type=script&lang=js"
import style0 from "./DashboardEgressProfile.vue?vue&type=style&index=0&id=06fd25e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd25e2",
  null
  
)

export default component.exports